import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon } from 'lucide-react';
const plans = [{
  tag: 'MEGAPACK ESI PRIMARIA',
  title: 'Megapack ESI Primaria',
  features: ['Más de 250 actividades listas para imprimir', 'Primer Ciclo completo', 'Segundo Ciclo completo', 'BONUS 1: Emergentes ESI', 'BONUS 2: Actividades Express ESI', 'BONUS 3: Afiches ESI para el Aula', 'BONUS 4: Ciudadanía Digital para Primaria', 'Acceso inmediato', 'Descarga digital'],
  price: '$19.990',
  href: 'https://checkout.aula-mater.online/cart/66898268749869:1',
  image: 'https://cdn.magicpatterns.com/uploads/qw9XxQHCdALsJhS46viPhX/mockup_principal.png',
  imageClass: 'max-h-44',
  highlighted: false
}, {
  tag: 'ESI + INCLUSIÓN',
  title: 'El pack más completo',
  subtitle: 'Con este combo cubrís inclusión educativa y ESI durante todo el año escolar',
  features: ['Todo el Megapack ESI Primaria', 'Todo el Megapack Inclusión Educativa', 'Más de 600 actividades adaptadas de Inclusión', 'Más de 250 actividades de ESI', 'Recursos para 1° a 6° grado', 'Material listo para imprimir', 'Todo el año escolar cubierto', 'El mayor ahorro'],
  price: '$29.990',
  href: 'https://checkout.aula-mater.online/cart/66898289197101:1',
  images: ['https://cdn.magicpatterns.com/uploads/qw9XxQHCdALsJhS46viPhX/mockup_principal.png', 'https://cdn.magicpatterns.com/uploads/1V7irRokAGQb8x3WtH72cb/mockup_inclusion.png'],
  imageClass: 'max-h-44',
  highlighted: true
}];
export function PurchaseSection() {
  return <section id="compra" className="py-8 px-4 bg-black text-white text-center" data-id="element-98">
      <div className="max-w-5xl mx-auto" data-id="element-99">
        <h2 className="text-[20px] font-black mb-2 text-[#EF5B4C]" data-id="element-100">
          Accedé ahora al Megapack ESI Primaria
        </h2>

        <p className="text-lg md:text-xl font-medium mb-6 max-w-2xl mx-auto text-gray-300" data-id="element-101">
          Elegí el plan que mejor se adapte a vos. Pago único · Acceso de por
          vida.
        </p>

        {/* Planes */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-3xl mx-auto items-stretch" data-id="element-102">
          {plans.map((plan, i) => <div key={i} className={`relative flex flex-col rounded-3xl p-6 md:p-7 text-left shadow-2xl border-2 ${plan.highlighted ? 'bg-[#16a34a] border-yellow-400 md:scale-105' : 'bg-gray-900 border-gray-800'}`} data-id="element-103">
              {plan.highlighted && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-yellow-400 text-gray-900 text-xs font-black px-4 py-1 rounded-full shadow-lg whitespace-nowrap" data-id="element-104">
                  ⭐ MÁS ELEGIDO
                </div>}

              <span className={`inline-block self-start text-[10px] md:text-xs font-black px-3 py-1 rounded-full mb-3 uppercase tracking-wide ${plan.highlighted ? 'bg-white/20 text-white' : 'bg-gray-800 text-gray-300'}`} data-id="element-105">
                {plan.tag}
              </span>

              <h3 className="text-2xl md:text-3xl font-black mb-1 text-white" data-id="element-106">
                {plan.title}
              </h3>
              {plan.subtitle && <p className="text-sm font-bold text-yellow-300 mb-3" data-id="element-107">
                  {plan.subtitle}
                </p>}

              <ul className="space-y-2 mb-6 mt-2 flex-grow" data-id="element-108">
                {plan.features.map((f, idx) => <li key={idx} className="flex items-start text-sm md:text-base" data-id="element-109">
                    <CheckIcon className={`w-5 h-5 mr-2 flex-shrink-0 mt-0.5 ${plan.highlighted ? 'text-yellow-300' : 'text-green-500'}`} data-id="element-110" />
                    <span className={plan.highlighted ? 'text-white' : 'text-gray-200'} data-id="element-111">
                      {f}
                    </span>
                  </li>)}
              </ul>

              {plan.images ? <div className="flex justify-center items-end gap-3 mb-4" data-id="element-112">
                  {plan.images.map((src, idx) => <img key={idx} src={src} alt={plan.title} className={`w-auto ${plan.imageClass} object-contain drop-shadow-xl rounded-lg`} data-id="element-113" />)}
                </div> : plan.image && <div className="flex justify-center mb-4" data-id="element-114">
                    <img src={plan.image} alt={plan.title} className={`w-auto ${plan.imageClass} object-contain drop-shadow-xl rounded-lg`} data-id="element-115" />
                  </div>}

              <div className="mb-4" data-id="element-116">
                <span className="text-gray-400 text-sm font-bold align-top mr-1" data-id="element-117">
                  ARS
                </span>
                <span className="text-4xl md:text-5xl font-black text-white" data-id="element-118">
                  {plan.price}
                </span>
                <p className={`text-xs mt-1 ${plan.highlighted ? 'text-white/80' : 'text-gray-400'}`} data-id="element-119">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <CTAButton href={plan.href} className={`w-full text-lg md:text-xl py-4 ${plan.highlighted ? '!bg-white !text-gray-900 !shadow-[0_0_20px_rgba(255,255,255,0.3)] !from-white !to-white' : ''}`} data-id="element-120">
                👉 LO QUIERO
              </CTAButton>
            </div>)}
        </div>

        {/* WhatsApp + muestra */}
        <div className="max-w-md mx-auto mt-8" data-id="element-121">
          <CTAButton href="https://wa.me/5491124676057?text=Hola%20te%20hablo%20por%20el%20Megapack%20ESI%20Primaria%2C%20quiero%20realizar%20la%20compra%20por%20Whatsapp%20u%20obtener%20mas%20informacion." className="w-full text-lg md:text-xl py-4 mb-4 flex items-center justify-center gap-3 !bg-gradient-to-r !from-[#25D366] !to-[#128C7E] !shadow-[0_0_20px_rgba(37,211,102,0.4)]" data-id="element-122">
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" data-id="element-123">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-124" />
            </svg>
            COMPRA POR WHATSAPP
          </CTAButton>

          <a href="https://drive.google.com/file/d/1VWCDiZ3t9i9Hld7P5Ui_Xckkou2KUJZE/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-block text-lg font-bold text-yellow-400 hover:text-yellow-300 underline underline-offset-4 mb-4 transition-colors" data-id="element-125">
            📄 Ver muestra gratis
          </a>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-sm font-bold text-gray-300" data-id="element-126">
            <span className="flex items-center" data-id="element-127">
              <span className="text-green-500 mr-1" data-id="element-128">✔</span> para 1° a 6° grado
            </span>
            <span className="flex items-center" data-id="element-129">
              <span className="text-green-500 mr-1" data-id="element-130">✔</span> acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-131">
              <span className="text-green-500 mr-1" data-id="element-132">✔</span> descarga digital
            </span>
            <span className="flex items-center" data-id="element-133">
              <span className="text-green-500 mr-1" data-id="element-134">✔</span> uso ilimitado
            </span>
          </div>
        </div>
      </div>
    </section>;
}